import React, { useState } from 'react';
import ApplicationForm from '../components/ApplicationForm';
import SpecializedPrograms from '../components/SpecializedPrograms';
import CelebratingAchievements from '../components/CelebratingAchievements';
import StudentServices from '../components/StudentServices';
import UniversityEvents from '../components/UniversityEvents';
import FAQ from '../components/FAQ';

const FAQs = () => {
  const [showApplicationModal, setShowApplicationModal] = useState(false);
  
  const faqs = [
    {
      question: "What is B.Tech Lateral Entry?",
      answer: "B.Tech Lateral Entry is a program designed for working professionals who have completed a diploma or have relevant work experience. It allows you to directly enter the second year of the B.Tech program."
    },
    {
      question: "What are the eligibility criteria?",
      answer: "You need a Polytechnic Diploma, B.Sc, or B.Voc degree with a minimum of 1 year of work experience in a relevant field."
    },
    {
      question: "Is the program UGC approved?",
      answer: "Yes, all our programs are UGC approved and AICTE recognized, ensuring the degree is valid and recognized nationwide."
    },
    {
      question: "What are the class timings?",
      answer: "We offer flexible shift timings to accommodate working professionals. Classes are conducted in the evening and on weekends."
    },
    {
      question: "Is there placement assistance?",
      answer: "Yes, we provide 24/7 placement assistance to help students find suitable job opportunities in their field of study."
    },
    {
      question: "What is the duration of the program?",
      answer: "The B.Tech Lateral Entry program is of 3 years duration, designed specifically for working professionals."
    },
    {
      question: "Are there any scholarships available?",
      answer: "Yes, we offer various scholarships and financial aid programs for eligible students. Please contact our admission office for details."
    },
    {
      question: "Can I study while working?",
      answer: "Absolutely! Our program is specifically designed for working professionals with flexible timings and online learning support."
    }
  ];

  return (
    <>
      <div className="container mt-5 pt-5">
      <div className="row">
        <div className="col-lg-12">
          <h1 className="text-center mb-5">Frequently Asked Questions</h1>
          
          <div className="accordion" id="faqAccordion">
            {faqs.map((faq, index) => (
              <div className="accordion-item" key={index}>
                <h2 className="accordion-header" id={`heading${index}`}>
                  <button 
                    className="accordion-button collapsed" 
                    type="button" 
                    data-bs-toggle="collapse" 
                    data-bs-target={`#collapse${index}`}
                    aria-expanded="false" 
                    aria-controls={`collapse${index}`}
                  >
                    {faq.question}
                  </button>
                </h2>
                <div 
                  id={`collapse${index}`} 
                  className="accordion-collapse collapse" 
                  aria-labelledby={`heading${index}`} 
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body">
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      </div>

      {/* Specialized Programs Section */}
      <SpecializedPrograms setShowApplicationModal={setShowApplicationModal} />

      {/* Celebrating Our Achievements Section */}
      <CelebratingAchievements />

      {/* Student Services Section */}
      <StudentServices />

      {/* University Events Section */}
      <UniversityEvents />

      {/* FAQ Section */}
      <FAQ />

      {/* Application Modal */}
      <ApplicationForm 
        show={showApplicationModal} 
        onHide={() => setShowApplicationModal(false)} 
      />
    </>
  );
};

export default FAQs;
